import React from "react";

export default function CustomLoading() {
  return (
    <>
      <div
        x-show="loaded"
        x-init="window.addEventListener('DOMContentLoaded', () => {setTimeout(() => loaded = false, 500)})"
        className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen bg-black/70! z-999999 dark:bg-black"
      >
        <div className="w-16 h-16 border-4 border-white border-solid rounded-full animate-spin border-t-transparent"></div>
      </div>
    </>
  );
}
